import React from 'react';
import ProfilePicker from '../ProfilePicker';
import ProfileData from '../ProfileData';
import MInput from './MInput';
import MCalc from './MCalc';

import './MDruckpunkte.css';

function MDruckpunkte(props) {
  return (
    <>
      <div className='MContainer'>
        <div className='MPicker'>
          <ProfilePicker />
        </div>
        <div className='MData'>
          <ProfileData />
        </div>
        <div className='MInput'>
          <MInput />
        </div>
        <div className='Calculation'>
          <MCalc />
        </div>
      </div>
    </>
  );
}

export default MDruckpunkte;
